<template>
  <div>
    <link-button id="reset-contribution" class="px-0" link-color="brand"
      >Reset Contributions
    </link-button>
    <popover
      target="reset-contribution"
      triggers="click blur"
      custom-class="ancestors-popover"
      placement="top"
      ref="popover"
      :show-delay="0"
      :no-fade="true"
    >
      <div class="text-medium-1">
        <h4 class="text-normal-1 mb-3">Contribution options</h4>
        <b-form-radio-group id="radio-slots" v-model="selected" name="radio-options-slots">
          <b-form-radio value="kr" name="radio-size">
            Only <b>Key Results</b> contribute
          </b-form-radio>
          <b-form-radio class="mt-1" value="kr+child_goal" name="radio-size">
            <b>Key Results + Child goals</b> contribute
          </b-form-radio>
        </b-form-radio-group>
      </div>
      <link-button class="mt-2 px-0" id="reset-contribution" link-color="brand" @click="onSubmit"
        >Apply
      </link-button>
    </popover>
  </div>
</template>

<script>
import LinkButton from '@/components/buttons/LinkButton'
import Popover from '@/components/Popover'
import { BFormRadio, BFormRadioGroup } from 'bootstrap-vue'

/**
 * This gives control to reset goal contributions. While resetting, user can choose between two options:
 *  - Distribute equal contribution amongst KRs only
 *  - Distribute equal contribution amongst KRs as well as Child goals
 */
export default {
  name: 'ResetContributions',
  props: ['hasChildGoal'],
  components: {
    LinkButton,
    Popover,
    BFormRadio,
    BFormRadioGroup
  },
  data() {
    return {
      selected: 'kr'
    }
  },
  computed: {},
  methods: {
    onSubmit() {
      this.$emit('reset', this.selected)
      this.$refs.popover.close()
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
